import APIClient from '../../functions/APIClient';

const signUp = (username: string, password: string, confirmPassword: string) => {
  return APIClient('/api/user/register/', {
    method: 'POST',
    body: { username, password, confirm_password: confirmPassword },
  });
};

export default signUp;
